import { ComponentPropsWithoutRef } from 'react';
import { UnstyledButton, Stack, Text, Box } from '@mantine/core';
import classes from './UserNavItem.module.css';

export type UserNavItemProps = ComponentPropsWithoutRef<'button'> & {
    isExpanded: boolean;
    username: string;
    email: string;
    initials: string;
    onClick?: () => void;
};

export const UserNavItem = ({
    username,
    email,
    initials,
    className,
    isExpanded,
    onClick,
    ...rest
}: UserNavItemProps) => {
    return (
        <UnstyledButton
            type="button"
            className={`${classes.userNavItem} ${className ?? ''}`}
            data-open={isExpanded ? 'true' : 'false'}
            aria-label={username}
            onClick={onClick}
            {...rest}
        >
            <Box className={classes.avatar}>
                <Text fz={12} fw={700} lh={1}>
                    {initials}
                </Text>
            </Box>

            <Stack gap={0} className={classes.textCol}>
                <Text fz={12} fw={500} truncate title={username}>
                    {username}
                </Text>
                <Text fz={10} truncate title={email}>
                    {email}
                </Text>
            </Stack>
        </UnstyledButton>
    );
};
